import FormCaptcha from '~/client/shared/form/FormCaptcha';
import FormError from '~/client/shared/form/FormError';
import FormInput from '~/client/shared/form/FormInput';
import Stack from '~/client/shared/Stack';
import FlexStack from '~/client/shared/styles/FlexStack';
import useFormRegisterFastSignup from './useFormRegisterFastSignup';
import IAgreeToTermsText from '../../../Authenticate/AuthSteps/FinishSignupStep/IAgreeToTermsText';
import SubmitButtonFormItem from '../../../Authenticate/AuthSteps/shared/SubmitButtonFormItem';

type Props = {
  isPopover?: boolean;
  onSuccess?: () => void;
};

const FormRegisterFastSignup: FC<Props> = ({
  onSuccess,
  isPopover = false,
}) => {
  const {
    errors,
    control,
    isCaptchaRequired,
    required,
    recaptchaRef,
    loading,
    handleSubmit,
    isSubmitDisabled,
    termsLabel,
  } = useFormRegisterFastSignup({ isPopover, onSuccess });

  return (
    <form>
      <Stack>
        <FormInput
          {...required('email')}
          type="email"
          label="profile.email"
          autoCapitalize="off"
          error={errors.email?.message}
        />
        <FormInput
          {...required('password')}
          type="password"
          label="profile.password"
          error={errors.password?.message}
        />
        {isCaptchaRequired && (
          <FormCaptcha
            ref={recaptchaRef}
            name="captcha"
            control={control}
            error={errors.captcha?.message}
            rules={{ required: isCaptchaRequired && 'errors.input.required' }}
          />
        )}
        <FlexStack inline>
          <IAgreeToTermsText label={termsLabel} />
        </FlexStack>
        {errors?.global?.message && (
          <FormError
            message={errors.global.message}
            data-testid={errors?.global?.message}
          />
        )}
        <SubmitButtonFormItem
          loading={loading}
          handleSubmit={handleSubmit}
          isSubmitDisabled={isSubmitDisabled}
          translateId="profile.signup-button"
          dataTestId="register-submit"
        />
      </Stack>
    </form>
  );
};

export default FormRegisterFastSignup;
